<template lang="pug">
v-card(flat).fill-height.d-flex.align-center.grey.lighten-4
  v-card-text.text-center
    .text-h5.my-3(
      v-if="tab === 0"
    ) Формирование удостоверений
    .text-h5.my-3(
      v-else-if="tab === 1"
    ) Подписание удостоверений

    p Выбрано всего
      strong  {{ item.length }}
    .my-5
      v-btn(
        color="secondary"
        depressed
        rounded
        x-large
        :disabled="!item.length"
        @click="handleBtn"
      )
        //- loading
        span {{ tab ? 'Подписать' : 'Сформировать'}}
        v-icon(right) mdi-checkbox-marked-circle-outline

  portal(
    v-if="tab === 1"
    to="sign.dialog" v-slot="{ attrs }"
  )
    v-card.sdo-card
      v-card-title Массовая подпись удостоверения
      v-card-text
        certificate-sign(
          :selected="item"
          :unSelected="unSelected"
          @sign="close"
        )
</template>
<script>
import CertificateSign from './CertificateSign.vue';

export default {
  components: {
    CertificateSign,
  },
  props: {
    item: { type: Array, required: true },
    tab: { type: Number, required: true },
    unSelected: { type: Array, default: () => [] },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('unSelect');
      this.$toasted.success('Успешно');
      this.$modals.close();
    },
    handleBtn() {
      const type = this.tab ? 'dialog-portal' : 'form-controller';
      const selectedLength = this.item.length;
      const notEmptySelectedLength = Object.values(this.item).length;
      const isUnselect = notEmptySelectedLength !== selectedLength;
      const attrs = this.tab ? {
        inputValue: 'sign',
      } : {
        title: 'Формирование удостоверений',
        message: `Будет сформировано ${this.item.length} удостоверений`,
        fields: [{
          component: 'v-text-field',
          text: 'Введите серийный номер',
          value: 'serial',
          rules: 'required|length:4',
          component_attrs: {
            counter: 4,
            filled: true,
            rounded: true,
          },
        }],
        method: ({ data }) => {
          const payload = {
            ...data,
            prior_record_user_ids: this.unSelected.length || isUnselect ? [] : this.item,
            exclude_prior_record_user_ids: this.unSelected,
          };
          return this.$api.diploma.createDiplomas(payload).then(() => this.close());
        },
      };
      this.$modals.show(type, attrs);
    },
  },
};
</script>
